module.exports = __webpack_public_path__ + "SymbolicaLogo.png";